import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Noticia } from 'src/app/models/Noticia';
import { NoticiaService } from 'src/app/services/noticia.service';
import { take } from 'rxjs/operators';
import { sortArray } from '../../../_fake/fake-helpers/http-extenstions';

@Component({
  selector: 'app-noticias-widget',
  templateUrl: './noticias-widget.component.html',
  styleUrls: ['./noticias-widget.component.scss']
})
export class NoticiasWidgetComponent implements OnInit {

  loadingNewsSummary$: Observable<boolean>;
  listNoticias: Noticia[] = [];
  isLoading: boolean = false;

  constructor(public noticiaService: NoticiaService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.noticiaService.latestNews().subscribe((response) => {
      this.listNoticias = this.getRandomItems(response.data, 4).sort((a, b) => {
        // Convertir 'fecha' a Date si es una cadena
        const fechaA = (typeof a.fecha === 'string') ? new Date(a.fecha) : a.fecha;
        const fechaB = (typeof b.fecha === 'string') ? new Date(b.fecha) : b.fecha;
      
        return fechaB.getTime() - fechaA.getTime();
      });
      this.isLoading = false;
    });
  }
  
  shuffleArray<T>(array: T[]): T[] {
    let currentIndex = array.length, temporaryValue, randomIndex;
  
    // Mientras queden elementos a mezclar...
    while (0 !== currentIndex) {
      // Seleccionar un elemento restante...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex -= 1;
  
      // E intercambiarlo con el elemento actual
      temporaryValue = array[currentIndex];
      array[currentIndex] = array[randomIndex];
      array[randomIndex] = temporaryValue;
    }
  
    return array;
  }  

  getRandomItems<T>(array: T[], numItems: number): T[] {
    // Primero mezclamos el array
    let shuffledArray = this.shuffleArray(array);
    // Luego seleccionamos los primeros X elementos
    return shuffledArray.slice(0, numItems);
  }
  

}
